import { Link } from 'react-router-dom'
import React from 'react'

export default function PolicyLinks() {
  return <>Please read our <Link to="/terms">terms of service</Link> and <Link to="/privacy">privacy policy</Link>.</>
}
